interface Props {
  label: string
  state: boolean
  disabled?: boolean
  labelClassName?: string
  size?: 'sm' | 'md'
  onChange: () => void
}

export function Switch({ label, state, onChange, disabled = false, labelClassName, size = 'md' }: Props) {
  const isSm = size === 'sm'
  const track = isSm
    ? `w-8 h-[18px] after:h-3.5 after:w-3.5 after:top-[2px] after:start-[2px]`
    : `w-11 h-6 after:h-5 after:w-5 after:top-[2px] after:start-[2px]`
  const labelText = isSm ? 'ml-2 text-xs font-medium' : 'mx-3 text-sm font-medium'

  return (
    <div className={isSm ? 'flex items-center' : 'items-center mx-3'}>
      <label className={`inline-flex items-center ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
        <input
          type="checkbox"
          value=""
          className="sr-only peer"
          onChange={() => !disabled && onChange()}
          checked={state}
          disabled={disabled}
        />
        <div
          className={`relative ${track} bg-gray-200 peer-focus:outline-none peer-focus:ring-4
          peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
          peer-checked:after:border-white after:content-[''] after:absolute
          after:bg-white after:border-gray-300 after:border after:rounded-full after:transition-all peer-checked:bg-blue-600
          ${disabled ? 'opacity-50' : ''}`}
        />
        <span className={`${labelText} ${labelClassName || 'text-gray-900'}`}>{label}</span>
      </label>
    </div>
  )
}
